module.exports = __webpack_public_path__ + "img/description1.074d2b34.jpg";